import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';

import { usePrevious } from '../../hooks/usePrevious';
import { Button, ButtonProps } from './button';

const LoadingComponent = ({ loadingText }) => {
  if (loadingText) {
    return loadingText;
  }
  return <Spinner size="sm" animation="border" />;
};

interface Props extends ButtonProps {
  isLoading?: boolean;
  savedText?: string;
  loadingText?: string;
  'data-accesskey'?: string;
}

export const ProgressButton = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const [contents, setContents] = useState<any>(props.children);
  const [keepDisabled, setKeepDisabled] = useState<boolean>(false);
  const [wasClicked, setWasClicked] = useState<boolean>(false);
  const { isLoading, savedText, ...passthroughProps } = props;
  const prevIsLoading = usePrevious(isLoading);

  useEffect(() => {
    setContents(props.children);
  }, [props.children]);

  useEffect(() => {
    if (savedText && wasClicked) {
      if (prevIsLoading === true && isLoading === false) {
        setContents(savedText);
        setKeepDisabled(true);

        setTimeout(() => {
          setContents(props.children);
          setKeepDisabled(false);
        }, 2000);
      }
    }
  }, [isLoading, wasClicked]);

  // we're hijacking the click event to make sure that we can
  // show the "saved" state - as the button may be in the loading
  // state upon initial load
  const clickInterceptor = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setWasClicked(true);
    return props.onClick && props.onClick(e);
  };

  return (
    <Button
      {...passthroughProps}
      data-accessKey={props['data-accesskey']}
      disabled={props.disabled || isLoading || keepDisabled}
      onClick={clickInterceptor}
      ref={ref}
    >
      {isLoading ? <LoadingComponent loadingText={props.loadingText} /> : contents}
    </Button>
  );
});
